import React from 'react'
import { Link } from 'react-router-dom'
import { useSession } from 'app/session'
import { format } from 'date-fns'
import env from 'env'

export default function Footer() {
  const session = useSession()

  return (
    <footer className="bg-white py-12 font-roboto-light border-t border-gray-200 font-light text-base leading-relaxed text-gray-900">
      <div className="container">
        <div className="flex flex-col sm:flex-row">
          <div className="w-full sm:w-1/3 px-4 mb-4">
            <ul>
              {session.isLoggedIn ? (
                <>
                  <li><Link to="/catering" className="text-aegean font-roboto hover:underline">Catering</Link></li>
                  <li><Link to="/public-events" className="text-aegean font-roboto hover:underline">Vending</Link></li>
                  <li><Link to="/bookings" className="text-aegean font-roboto hover:underline">My Bookings</Link></li>
                  <li><a href="https://roaminghunger.helpscoutdocs.com/" className="text-aegean font-roboto hover:underline">Frequently Asked Questions</a></li>
                </>
              ) : (
                <>
                  <li><a href="/" className="text-aegean font-roboto hover:underline">Home</a></li>
                  {/* 
                  <li><a href="/get-started" className="text-aegean hover:underline">Get Started</a></li>
                  <li><a href="/login" className="text-aegean hover:underline">Login</a></li> 
                  */}
                </>
              )}
              <li><hr className="my-4" /></li>
              <li>© {format(new Date(), 'yyyy')} Mobile Food Alliance</li>
              <li className="mt-2 text-xs">
                 <a className="text-aegean font-roboto mr-1 hover:underline" href="https://privacy.cptn.co/privacy-policy/050bde31-2b64-4f85-a626-2f274c4e0223" target="_blank" rel="noreferrer">Privacy Notice</a>
                 | <a className="text-aegean font-roboto mr-1 hover:underline" href="https://dsar.cptn.co/dsar/6150ead0-59d6-4452-b529-fec5bf67f68b" target="_blank" rel="noreferrer">Data Subject Rights</a>
                 | <a className="text-aegean font-roboto hover:underline" href="https://roaminghunger.com/pages/terms_and_conditions/" target="_blank">Terms &amp; Conditions</a>
              </li>
              <li className="mt-2 text-xs">Version: {env.APP_VERSION || 'n/a'}</li>
            </ul>
          </div>
          <div className="w-full sm:w-1/3 px-4 mb-4">
            <p className="sm:text-center">
              <strong>QUESTIONS?</strong>
              <br />CALL US Monday-Friday 9-5PM PST 
              <br />1 (800) 568-9370 ext. 3
              <br /><a className="text-aegean font-roboto hover:underline" href="mailto:info@mobilefoodalliance.com">info@mobilefoodalliance.com</a>
            </p>
          </div>
          <div className="w-full sm:w-1/3 px-4 mb-4"></div>
        </div>
      </div>
    </footer>
  )
}
